import * as R from 'ramda'
import {
  Equipment,
  EquipmentGroups,
  Offer,
  ContractType,
  EquipmentSfId,
  EquipmentContract,
  BuildingSfId,
  OpportunityContract
} from '../../types/types.d'
type contractDate = 'start' | 'end'

export const getContractTypeForOffer = (offer: Offer) => {
  const buildings = R.pathOr({}, ['opportunity', 'contracts', 0, 'buildings'], offer)
  const values = R.values<Record<BuildingSfId, Record<EquipmentSfId, EquipmentContract>>>(buildings)
  const contractTypes = R.chain(equipment => R.values(equipment).map((e: EquipmentContract) => e.contractType), values)
  return getMostFrequentValueFromList(contractTypes)
}

export const getRushContractType = (equipmentGroups: EquipmentGroups) => (equipment: Equipment) => {
  const { groupId, equipmentCategory } = equipment
  const rushTypeForCriticality = () =>
    R.path([groupId, equipmentCategory, 'selections', 'KCSM_KCC_CONTRACT_TYPE'], equipmentGroups) as ContractType

  return rushTypeForCriticality()
}

export const getRushContractTypeForOffer = (offer: Offer) => {
  const { active, rushContractType } = offer.isEscalationFlow
  if (active) {
    return rushContractType
  }
  const equipment = getEquipmentForOffer(offer)
  const rushContractTypeFor = getRushContractType(offer.equipmentGroups)
  const contractTypes = R.map(e => rushContractTypeFor(e), equipment)
  return getMostFrequentValueFromList(contractTypes)
}

export const getEquipmentForOffer = (offer: Offer) => {
  if (!offer.buildings) {
    return []
  }
  const equipment = []
  for (const building of offer.buildings) {
    for (const e of building.details.equipment) {
      equipment.push(e)
    }
  }
  return equipment
}

export const getMostFrequentValueFromList = <T>(list: T[]) => {
  list.sort()
  let mostFrequentIndex = 0
  let longestStreak = 1
  let currentStreak = 1
  for (let i = 1; i < list.length; i++) {
    const prev = list[i - 1]
    const curr = list[i]
    if (curr === prev) {
      currentStreak += 1
      if (currentStreak > longestStreak) {
        longestStreak = currentStreak
        mostFrequentIndex = i
      }
    } else {
      currentStreak = 1
    }
  }
  return list[mostFrequentIndex]
}
export const getEarliestDate = (contracts: OpportunityContract[], sortBy: contractDate) => {
  const sortStart = (a: OpportunityContract, b: OpportunityContract) => Date.parse(a.start) - Date.parse(b.start)
  const sortEnd = (a: OpportunityContract, b: OpportunityContract) =>
    a.end && b.end ? Date.parse(a.end) - Date.parse(b.end) : a.end ? -1 : 1
  if (contracts.length > 0) {
    const sortContract = [...contracts]
    sortContract.sort(sortBy === 'start' ? sortStart : sortEnd)
    return sortContract[0][sortBy]
  }
  return null
}
